import { render, staticRenderFns } from "./QScoreCardTotalAgencyRegistrations.vue?vue&type=template&id=31f3480d&scoped=true&"
import script from "./QScoreCardTotalAgencyRegistrations.vue?vue&type=script&lang=js&"
export * from "./QScoreCardTotalAgencyRegistrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3480d",
  null
  
)

export default component.exports